import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FieldDefinition } from './field-definition';

@Component({
    selector: 'fw-dynamic-field',
    template: require('./dynamic-field.component.html'),
    styles: [require('./dynamic-field.component.css')]
})
export class DynamicFieldComponent {
    @Input() field: FieldDefinition;
    @Input() form: FormGroup;
    @Input() operation: string;
    @Input() submitted: boolean;

    get isValid() { return this.form.controls[this.field.key].valid; }

    constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/dynamic-forms/dynamic-field.component.ts